import { Ref } from 'react'

// util to merge multiple refs into one
export function mergeRefs<T = unknown>(...refs: Array<Ref<T> | undefined>) {
  return (value: T | null) => {
    refs.forEach(ref => {
      if (!ref) return
      if (typeof ref === 'function') {
        ref(value)
      } else {
        // @ts-ignore
        ref.current = value
      }
    })
  }
}
